<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'schedule/index' }">
                                Jadwal
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Jadwal Pengajar
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div class="row px-3">
            <div class="col-12">
                <form v-on:submit.prevent="paginate(1, false)">
                    <div class="row d-md-flex d-none">
                        <template v-if="roleElligibleView()">
                            <div class="col-2 px-1">
                                <label class="text-muted mb-0">Filter Nama Pengajar</label>
                            </div>
                            <div class="col-2 px-1">
                                <label class="text-muted mb-0">Search</label>
                            </div>
                        </template>
                        <div class="col-4 px-1">
                            <label class="text-muted mb-0">Interval</label>
                        </div>
                        <div class="col-md px-1">
                            <label class="text-muted mb-0">Periode</label>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <template v-if="roleElligibleView()">
                            <div class="col-md-2 col-sm-6 px-1 mt-2">
                                <select v-model="form.filter.teacherID" class="form-control form-control-sm">
                                    <option value="">Pilih Nama Pengajar...</option>
                                    <option v-for="teacher in teachers" v-bind:value="teacher.userID" v-bind:key="teacher.userID">{{ teacher.user.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-2 col-sm-6 px-1 mt-2">
                                <input v-model="form.filter.keyword" class="form-control form-control-sm" placeholder="Search..." />
                            </div>
                        </template>
                        <div class="col-md-2 col-sm-6 px-1 mt-2">
                            <datepicker v-model="form.filter.start" v-bind:language="dateLanguage" full-month-name monday-first clear-button input-class="form-control form-control-sm"></datepicker>
                        </div>
                        <div class="col-md-2 col-sm-6 px-1 mt-2">
                            <datepicker v-model="form.filter.end" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{to: form.filter.start}" input-class="form-control form-control-sm"></datepicker>
                        </div>
                        <div class="col-md-2 col-sm-6 px-1 mt-2">
                            <select v-model="form.filter.semester" class="form-control form-control-sm">
                                <option value="">Pilih Periode...</option>
                                <option v-for="semester in semesters" v-bind:value="semester.id" v-bind:key="semester.id">{{ semester.name }}</option>
                            </select>
                        </div>
                        <div class="col-auto px-1 mt-2">
                            <button type="submit" class="btn btn-danger btn-sm px-3">
                                Search
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-3" v-on:click="download">
                                Download
                            </button>
                        </div>
                        <div class="col-md-auto col ml-auto px-1 mt-2 text-right" v-if="profile.isAdmin">
                            <button type="button" class="btn btn-outline-danger btn-sm px-4 mb-0 mx-1" v-b-tooltip.hover title="Upload data jadwal" v-on:click="modal.upload = true">
                                Upload
                            </button>
                            <button type="button" class="btn btn-outline-danger btn-sm px-4 mx-1" v-on:click="modal.add = true" v-b-tooltip.hover title="Menambahkan data siswa baru">
                                Create
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mb-4">
                <div id="table-primary" class="table-responsive" v-dragscroll="!isMobile()">
                    <table class="table">
                        <thead>
                            <tr class="text-danger font-weight-bold">
                                <th scope="col">
                                    Tanggal
                                </th>
                                <th scope="col">
                                    Lokasi BTA
                                </th>
                                <th scope="col">
                                    Program Kelas
                                </th>
                                <th scope="col">
                                    Kelas BTA
                                </th>
                                <th scope="col">
                                    Sesi
                                </th>
                                <th scope="col">
                                    Nama Pengajar
                                </th>
                                <th scope="col">
                                    Mata Pelajaran
                                </th>
                                <!--<th scope="col">
                                    Periode
                                </th>-->
                                <th scope="col">
                                    Track Pelajaran
                                </th>
                                <th scope="col">
                                    Status Kehadiran
                                </th>
                                <th scope="col">
                                    Laporan Pengajar
                                </th>
                                <template v-if="roleElligibleAttend()">
                                    <th scope="col">
                                        Kehadiran Pengajar
                                    </th>
                                    <th scope="col">
                                        Kehadiran Siswa
                                    </th>
                                </template>
                                <th scope="col">
                                    Total Kehadiran
                                </th>
                                <th scope="col" style="min-width: 140px;" v-if="roleElligibleModified()">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="shadow-sm" v-for="session in sessions" v-bind:key="session.id">
                                <td>
                                    <span class="text-loading">{{ [session.date, "YYYY-MM-DD"] | moment("dddd, D MMMM YYYY") }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ session.branchClass.pattern.branchProgram.branch.name }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ session.branchClass.pattern.branchProgram.grade.name }}<br />{{ session.branchClass.pattern.branchProgram.programType.name }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ session.branchClass.name }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ session.slot }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ session.teacher.employee.user.name }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ session.subject.name }}</span>
                                </td>
                                <!--<td>
                                    <span class="text-loading">{{ periodLabel(session) }}</span>
                                </td>-->
                                <td>
                                    <button v-on:click="track(session.id)" type="button" class="btn btn-link btn-sm">
                                        Track Pelajaran
                                    </button>
                                </td>
                                <td>
                                    {{ session.status }}
                                    <p v-if="session.additionalStatus">({{ session.additionalStatus }})</p>
                                </td>
                                <td>
                                    <router-link v-if="session.evaluation" v-bind:to="{name: 'evaluation/view', params: {id: session.evaluation.id}}">
                                        Laporan Pengajaran
                                    </router-link>
                                    <button v-else-if="roleElligibleEvaluation()" type="button" class="btn btn-link btn-sm" v-on:click="modal.evaluation = true; form.evaluation.sessionID = session.id;">
                                        Laporan Pengajaran
                                    </button>
                                </td>
                                <template v-if="roleElligibleAttend()">
                                    <td>
                                        <button href="#" type="button" class="btn btn-link btn-sm" v-on:click="modal.attend = true; form.session = Object.assign({}, session);">
                                            Kehadiran Pengajar
                                        </button>
                                    </td>
                                    <td>
                                        <router-link v-bind:to="{name: 'schedule/attend', params: {id: session.id, semester: session.semester}}">
                                            Kehadiran Siswa
                                        </router-link>
                                    </td>
                                </template>
                                <td>
                                    {{ session.studentAttendances }}/{{ session.totalStudents }}
                                </td>
                                <td v-if="roleElligibleModified()">
                                    <button type="button" class="btn btn-link btn-sm mr-2" v-on:click="modal.update = true; form.session = session;" v-if="roleElligibleEdit(session)">
                                        Edit
                                    </button>
                                    <button v-if="profile.isAdmin" v-on:click="modal.remove = true; removeReference = session" type="button" class="btn btn-link btn-sm">
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>

        <b-modal v-model="modal.track" v-on:hide="tracks = []" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" size="lg">
            <template slot="modal-header">
                <h4 class="container text-white font-weight-bold text-center mb-0">
                    Track Pelajaran
                </h4>
            </template>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="table-responsive px-2">
                            <table class="table">
                                <thead>
                                    <tr class="text-danger font-weight-bold">
                                        <th scope="col" class="bg-transparent">
                                            Hari
                                        </th>
                                        <th scope="col" class="bg-transparent">
                                            Tanggal
                                        </th>
                                        <th scope="col" class="bg-transparent">
                                            Materi
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="shadow-sm" v-for="track in tracks">
                                        <td class="text-center">
                                            <span class="text-loading">{{ [track.date, "YYYY-MM-DD"] | moment("dddd") }}</span>
                                        </td>
                                        <td>
                                            <span class="text-loading">{{ [track.date, "YYYY-MM-DD"] | moment("D MMMM YYYY") }}</span>
                                        </td>
                                        <td>
                                            <span class="text-loading">{{ track.topic }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 mb-4">
                        <button class="btn btn-outline-danger btn-sm float-right px-5 mx-2" v-on:click="modal.track = false">
                            Keluar
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="modal.attend" v-if="roleElligibleAttend()" v-on:hide="form.session = {}" modal-class="border-0" body-class="px-4" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-white font-weight-bold text-center mb-0">
                    Kehadiran Pengajar
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="save">
                    <div class="row">
                        <div class="col-12 mb-2 text-center">
                            <div class="form-check form-check-inline py-1 pl-1" v-for="(status, index) in statuses">
                                <div class="custom-control custom-radio">
                                    <input v-model="form.session.status" type="radio" class="custom-control-input" v-bind:value="status" v-bind:id="'input-attend-' + index" />
                                    <label class="custom-control-label" v-bind:for="'input-attend-' + index">{{ status }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-3 px-5">
                            <textarea v-model="form.session.additionalStatus" class="form-control toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="Keterangan"></textarea>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-outline-danger btn-sm px-5">
                                Submit
                            </button>
                            <button type="button" class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.attend = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-model="modal.update" v-if="roleElligibleModified()" v-on:hide="form.session = {}" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-white font-weight-bold text-center mb-0">
                    Edit
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="save">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-1 align-items-center" v-if="profile.isAdmin || (profile.isEmployee && profile.employee.isBranchStaff && profile.employee.isMentor)">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Mata Pelajaran</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.session.subjectID" class="form-control form-control-sm" required>
                                        <option value="">Pilih Mata Pelajaran...</option>
                                        <option v-for="subject in subjects" v-bind:value="subject.id" v-bind:key="subject.id">{{ subject.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-if="form.session.subjectID !== ''">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Nama Pengajar</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.session.teacherID" class="form-control form-control-sm" required>
                                        <option value="">Pilih Nama Pengajar...</option>
                                        <option v-for="teacher in filterTeachers(form.session.subjectID)" v-bind:value="teacher.userID" v-bind:key="teacher.userID">{{ teacher.user.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-outline-danger btn-sm px-5">
                                Submit
                            </button>
                            <button type="button" class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.update = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-model="modal.evaluation" v-if="roleElligibleEvaluation()" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-white font-weight-bold text-center mb-0">
                    Laporan Pengajaran
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="evaluation">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Bab</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.evaluation.topic" class="form-control toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Sub Bab</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.evaluation.subtopic" class="form-control toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Jumlah Soal yang Dibahas</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.evaluation.question" type="number" class="form-control toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-if="roleElligibleAttend()">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Permasalahan Pengajar</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="form-check py-1 pl-1" v-for="(problem, index) in problems">
                                        <div class="custom-control custom-radio">
                                            <input v-model="form.evaluation.problem" type="radio" class="custom-control-input" v-bind:value="problem" v-bind:id="'input-problem-' + index" />
                                            <label class="custom-control-label" v-bind:for="'input-problem-' + index">{{ problem }}</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-auto pr-1">
                                            <div class="form-check py-1 pl-1">
                                                <div class="custom-control custom-radio">
                                                    <input v-model="form.evaluation.problem" type="radio" value="" class="custom-control-input" id="input-problem-other" />
                                                    <label class="custom-control-label" for="input-problem-other">Lainnya</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col pl-1">
                                            <input v-model="form.evaluation.otherProblem" v-bind:disabled="form.evaluation.problem !== '' && form.evaluation.problem !== null" class="form-control h4 mb-0 font-weight-medium form-control-sm"  />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-outline-danger btn-sm px-5">
                                Submit
                            </button>
                            <button type="button" class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.evaluation = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-model="modal.add" v-if="profile.isAdmin" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-white font-weight-bold text-center mb-0">
                    Create Jadwal
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="add">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Tanggal</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <datepicker v-model="form.add.date" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{to: $moment().subtract(1, 'day').toDate()}" input-class="form-control form-control-sm" required></datepicker>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Cabang</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="branchID" class="form-control form-control-sm" required>
                                        <option disabled value="">Pilih Cabang...</option>
                                        <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-if="branchID !== ''">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Program</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="branchProgramID" class="form-control form-control-sm" required>
                                        <option disabled value="">Pilih Program...</option>
                                        <option v-for="branchProgram in branchPrograms" v-bind:value="branchProgram.id" v-bind:key="branchProgram.id">{{ branchProgram.grade.name }} - {{ branchProgram.programType.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-if="branchProgramID !== ''">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Pola</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="patternID" class="form-control form-control-sm" required>
                                        <option disabled value="">Pilih Pola...</option>
                                        <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-if="patternID !== ''">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Kelas</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.add.branchClassID" class="form-control form-control-sm" required>
                                        <option disabled value="">Pilih Kelas...</option>
                                        <option v-for="branchClass in branchClasses" v-bind:value="branchClass.id" v-bind:key="branchClass.id">{{ branchClass.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Sesi</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.add.slot" class="form-control form-control-sm" type="number" min="1" max="6" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Mata Pelajaran</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.add.subjectID" class="form-control form-control-sm" required v-on:change="form.add.teacherID = ''">
                                        <option disabled value="">Pilih Mata Pelajaran...</option>
                                        <option v-for="subject in subjects" v-bind:value="subject.id" v-bind:key="subject.id">{{ subject.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-if="form.add.subjectID !== ''">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Nama Pengajar</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.add.teacherID" class="form-control form-control-sm" required>
                                        <option disabled value="">Pilih Nama Pengajar...</option>
                                        <option v-for="teacher in filterTeachers(form.add.subjectID)" v-bind:value="teacher.userID" v-bind:key="teacher.userID">{{ teacher.user.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Semester</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.add.semester" class="form-control form-control-sm">
                                        <option value="">Pilih Periode...</option>
                                        <option v-for="semester in semesters" v-bind:value="semester.id" v-bind:key="semester.id">{{ semester.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-outline-danger btn-sm px-5">
                                Submit
                            </button>
                            <button type="button" class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.add = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-if="profile.isAdmin" v-model="modal.upload" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload Nilai
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="upload">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-2 align-items-center">
                                <div class="col text-right">
                                    <a v-bind:href="'/static/template/data-sample-jadwal.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                        Download Template
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Periode</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.upload.semester" class="form-control form-control-sm">
                                        <option v-for="semester in semesters" v-bind:value="semester.id" v-bind:key="semester.id">{{ semester.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file-schedule" type="file" class="form-control" v-on:change="fileUpload($event, 'schedule')" placeholder="Choose File" accept=".xlsx, .xls, .csv" required />
                                    <label for="file-schedule" class="form-control form-control-sm text-truncate">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button>
                                        {{ form.upload.schedule.name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.upload = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-model="modal.remove" v-if="profile.isAdmin" v-on:hide="removeReference = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus jadwal ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.remove = false">
                            Batal
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import { dragscroll } from 'vue-dragscroll';
    import { employeeRoles, semesters } from '@/params.js';
    import { id } from 'vuejs-datepicker/dist/locale';
    import Paginate from 'vuejs-paginate';
    import Datepicker from 'vuejs-datepicker';
    import qs from 'qs';

    export default {
        name: "ScheduleIndex",
        directives: {dragscroll},
        components: {
            Paginate,
            Datepicker
        },
        computed: mapState([
            'profile',
            'term'
        ]),
        watch: {
            profile() {
                this.fetchData();
            },
            term() {
                this.paginate(this.page);
            },
            'form.filter.start'(start) {
                if (start) {
                    if (!this.form.filter.end || this.$moment(start).isAfter(this.$moment(this.form.filter.end))) {
                        this.form.filter.end = start;
                    }
                }
            },
            branchID(branchID) {
                if (branchID) {
                    this.axios.get(process.env.API_URL + '/branch-program', {params: {branchID: branchID}}).then(response => {
                        this.branchPrograms = response.data.data;
                    });
                } else {
                    this.branchPrograms = [];
                }
                this.branchProgramID = '';
            },
            branchProgramID(branchProgramID) {
                if (branchProgramID) {
                    this.axios.get(process.env.API_URL + '/pattern', {params: {branchProgramID: branchProgramID}}).then(response => {
                        this.patterns = response.data.data;
                    });
                } else {
                    this.patterns = [];
                }
                this.patternID = '';
            },
            patternID(patternID) {
                if (patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: patternID}}).then(response => {
                        this.branchClasses = response.data.data;
                    });
                } else {
                    this.branchClasses = [];
                }
                this.form.add.branchClassID = '';
            }
        },
        data() {
            return {
                form: {
                    filter: {
                        teacherID: '', keyword: '', start: this.$moment().toDate(), end: this.$moment().toDate(), semester: 1
                    },
                    session: {
                        id: '', status: '', additionalStatus: '', teacherID: '', subjectID: ''
                    },
                    evaluation: {
                        sessionID: '', topic: '', subtopic: '', question: '', problem: '', otherProblem: ''
                    },
                    add: {
                        date: '', branchClassID: '', slot: '', subjectID: '', teacherID: '', semester: ''
                    },
                    upload: {
                        schedule: '', semester: 1
                    }
                },
                pageCount: 0,
                page: 1,
                dateLanguage: id,
                teachers: [],
                subjects: [],
                sessions: [],
                tracks: [],
                branches: [],
                branchPrograms: [],
                patterns: [],
                branchClasses: [],
                branchID: '',
                branchProgramID: '',
                patternID: '',
                statuses: ['Hadir', 'Masuk Kelas', 'Tidak Hadir', 'Terlambat'],
                problems: ['Terlambat', 'Komplain Siswa'],
                removeReference: null,
                semesters: semesters,
                modal: {
                    add: false,
                    track: false,
                    attend: false,
                    update: false,
                    evaluation: false,
                    remove: false,
                    upload: false
                }
            };
        },
        methods: {
            paginate(page, scroll = true) {
                let interval = {
                    start: this.form.filter.start ? this.$moment(this.form.filter.start).format('YYYY-MM-DD') : '',
                    end: this.form.filter.end ? this.$moment(this.form.filter.end).format('YYYY-MM-DD') : ''
                };
                this.axios.get(process.env.API_URL + '/session', {params: Object.assign({}, this.form.filter, interval, {termID: this.term.id, page: page})}).then(response => {
                    this.sessions = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            download() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                let interval = {
                    start: this.form.filter.start ? this.$moment(this.form.filter.start).format('YYYY-MM-DD') : '',
                    end: this.form.filter.end ? this.$moment(this.form.filter.end).format('YYYY-MM-DD') : ''
                };
                window.location = process.env.API_URL + '/session/download?' + qs.stringify(Object.assign({}, this.form.filter, interval, {token: token, termID: this.term.id}), {encode: false});
            },
            track(id) {
                this.axios.get(process.env.API_URL + '/evaluation/track/' + id).then(response => {
                    this.tracks = response.data.data;
                    this.modal.track = true;
                });
            },
            save() {
                this.axios.post(process.env.API_URL + '/session/update-attendance/' + this.form.session.id, this.form.session).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modal.attend = false;
                        this.modal.update = false;
                        this.paginate(this.page, false);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            remove() {
                if (this.removeReference) {
                    this.axios.post(process.env.API_URL + '/session/delete/' + this.removeReference.id).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.paginate(this.page, false);
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                        this.modal.remove = false;
                        this.removeReference = null;
                    });
                }
            },
            evaluation() {
                if (this.form.evaluation.problem === '') {
                    if (this.form.evaluation.otherProblem !== '') {
                        this.form.evaluation.problem = this.form.evaluation.otherProblem;
                    }
                }
                this.axios.post(process.env.API_URL + '/evaluation', this.form.evaluation).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modal.evaluation = false;
                        for (let attribute in this.form.evaluation) {
                            this.form.evaluation[attribute] = '';
                        }
                        this.paginate(this.page, false);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            add() {
                this.form.add.date = this.form.add.date ? this.$moment(this.form.add.date).format('YYYY-MM-DD') : '';
                this.axios.post(process.env.API_URL + '/session', Object.assign({}, this.form.add, {termID: this.term.id})).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        for (let attribute in this.form.add) {
                            this.form.add[attribute] = '';
                        }
                        this.branchID = '';
                        this.paginate(this.page, false);
                        this.modal.add = false;
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            upload(event) {
                let formData = new FormData();
                for (let attribute in this.form.upload) {
                    formData.set(attribute, this.form.upload[attribute]);
                }

                this.axios.post(process.env.API_URL + '/session/upload', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.paginate(this.page, false);
                    } else {
                        let message = response.data.errors[Object.keys(response.data.errors)[1]][0] + ' at row ' + response.data.errors[0].row;
                        this.$toastr('warning', message, 'Warning');
                    }
                });
            },
            fileUpload(event, attribute) {
                var input = event.currentTarget;
                let files = input.files;
                if (files && files[0]) {
                    this.form.upload[attribute] = files[0];
                }
            },
            fetchData() {
                if (this.profile.isAdmin) {
                    this.axios.get(process.env.API_URL + '/branch').then(response => {
                        this.branches = response.data.data;
                    });
                }
                if (this.roleElligibleView()) {
                    this.axios.get(process.env.API_URL + '/employee/teacher').then(response => {
                        this.teachers = response.data.data;
                    });
                }
                if (this.roleElligibleSubject()) {
                    this.axios.get(process.env.API_URL + '/subject').then(response => {
                        this.subjects = response.data.data;
                    });
                }
            },
            filterTeachers(subjectID) {
                return subjectID ? this.teachers.filter(employee => employee.teacher.subjects.find(subject => subject.id === subjectID)) : [];
            },
            patternLabel(pattern) {
                return pattern.periods.map(period => {
                    return this.$moment.weekdays(period.day) + ' ' + this.$moment(period.start, "HH:mm:ss").format('HH.mm') + ' - ' + this.$moment(period.end, "HH:mm:ss").format('HH.mm');
                }).join(" | ");
            },
            periodLabel(session) {
                let semester = this.semesters.find(semester => semester.id === session.semester);
                return semester ? semester.name : '';
            },
            roleElligibleEvaluation() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isBranchStaff || this.profile.employee.isMentor || this.profile.employee.isTeacher));
            },
            roleElligibleSubject() {
                return this.profile.isAdmin || (this.profile.isEmployee && this.profile.employee.isBranchStaff);
            },
            roleElligibleAttend() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isBranchStaff || this.profile.employee.isMentor));
            },
            roleElligibleModified() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isBranchStaff || this.profile.employee.isCoordinator || this.profile.employee.isMentor ));
            },
            roleElligibleEdit(session) {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isBranchStaff || this.profile.employee.isMentor || (this.profile.employee.isCoordinator && this.profile.employee.coordinator.subjectID === session.subjectID)));
            },
            roleElligibleView() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager || this.profile.employee.isBranchStaff || this.profile.employee.isCoordinator || this.profile.employee.isMentor || this.profile.employee.isBranchHead));
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            }
        },
        created() {
            this.fetchData();
        },
        mounted() {
            this.paginate(1, false);
            document.title = 'List Schedule - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/schedule/Index.vue